// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getUserActivities, completeActivity } from '../services/activityService';

const Dashboard = () => {
  const { user } = useAuth();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserActivities();
  }, []);

  const fetchUserActivities = async () => {
    try {
      const data = await getUserActivities(user.id);
      setActivities(data);
      setLoading(false);
    } catch (error) {
      setError('Failed to load activities');
      setLoading(false);
    }
  };

  const handleCompleteActivity = async (activityId) => {
    try {
      await completeActivity(user.id, activityId);
      // Refresh the list
      fetchUserActivities();
    } catch (error) {
      setError('Failed to complete activity');
    }
  };

  // Check if user is admin
  const isAdmin = true ; //user && user.role === 'ADMIN';

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Welcome, {user.name}!</h1>
        {isAdmin && <span className="admin-badge">Admin</span>}
      </div>

      {/* Navigation Section */}
      <div className="dashboard-navigation">
        <div className="nav-section">
          <h2>Quick Links</h2>
          <div className="nav-cards">
            <div className="nav-card" onClick={() => navigate('/activities')}>
              <div className="nav-icon">📋</div>
              <h3>Activities</h3>
              <p>View and manage all activities</p>
            </div>

            {isAdmin && (
              <div className="nav-card" onClick={() => navigate('/users')}>
                <div className="nav-icon">👥</div>
                <h3>Users</h3>
                <p>Manage user accounts</p>
              </div>
            )}

            <div className="nav-card" onClick={() => navigate('/questionnaires')}>
              <div className="nav-icon">📝</div>
              <h3>Quizes</h3>
              <p>View all Quizes</p>
            </div>
            {isAdmin && (
              <div className="nav-card" onClick={() => navigate('/sugar-measurements')}>
                <div className="nav-icon">📊</div>
                <h3>Sugar Measurements</h3>
                <p>View health data reports</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;